// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info-list[data-v-0f653b62] {\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\n}\n.info-item[data-v-0f653b62] {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  border-bottom: 1px dotted lightgrey;\r\n  padding-bottom: 8px;\r\n  margin-bottom: 8px;\n}\r\n", ""]);
// Exports
module.exports = exports;
